import { FC, lazy } from 'react';
import { CustomCard } from '@mybonum/ui';
import { Typography } from 'antd';

export const DashboardPage: FC = () => (
    <CustomCard>
        <Typography.Title level={4}>To be delivered...</Typography.Title>
    </CustomCard>
);

export const DashboardPageLazy = lazy(async () => {
    const { DashboardPage } = await import('./page');

    return { default: DashboardPage };
});
